var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar'),(!['page', 'about'].includes(this.$route.name))?_c('HeroSection'):_vm._e(),_c('v-main',[_c('router-view')],1),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }